import { CircularProgress } from "@material-ui/core";
import { css, cx } from "emotion";
import React from "react";
import { useDropzone } from "react-dropzone";
import AppService from "../../Services/AppService/AppService";
import { handleError } from "../Utils/Utils";

const DragAndDropUpload = ({ target, accept, onUploadDone }) => {
  const [missingFileType, setMissingFileType] = React.useState(false);
  const [status, setStatus] = React.useState("waiting");
  const { acceptedFiles, getRootProps, open, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: accept,
    noClick: true,
    noKeyboard: true,
    onDropRejected: () => setMissingFileType(true),
    onDropAccepted: (files) => {
      setMissingFileType(false);

      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        setStatus("process");
        AppService.uploaderFile({ file: reader.result }, target)
          .then((response) => {
            setStatus("done");
            return onUploadDone(response);
          })
          .catch((error) => {
            setStatus("failed");
            handleError(error);
          });
      };
    },
  });
  const DropAreaRef = React.useRef();

  return (
    <form
      {...getRootProps({
        className:
          "w-100 w-100 d-flex flex-column justify-content-center align-items-center p-5",
      })}
      ref={DropAreaRef}
    >
      <span className="font-12 text-secondary font-bold text-center">
        Drag atau upload file disini
      </span>
      <input {...getInputProps()} />
      <button
        type="button"
        className={cx(
          css`
            border-radius: 8px;
            border: solid 1px #eeeeee;
          `,
          "btn btn-md py-2 px-3 font-bold font-12 mt-3"
        )}
        onClick={open}
      >
        {status === "waiting" && <React.Fragment>Upload</React.Fragment>}

        {status === "process" && (
          <React.Fragment>
            <CircularProgress size="1rem" />
            <span className="ml-2">Uploading</span>
          </React.Fragment>
        )}

        {status === "done" && (
          <React.Fragment>
            <span>Uploaded</span>
          </React.Fragment>
        )}

        {status === "failed" && (
          <React.Fragment>
            <span className="text-danger">Failed</span>
          </React.Fragment>
        )}
      </button>
      {acceptedFiles && (
        <span className="text-primary font-10 mt-3">
          {acceptedFiles[0]?.name}
        </span>
      )}
      {missingFileType && (
        <span className="text-danger font-10 mt-3">
          Missing file type. Only allowed csv file.
        </span>
      )}
    </form>
  );
};

export default DragAndDropUpload;
